


var Handle3dView = function (model, editorView, handleId) {
    var self = this;

    this.handleId = handleId;
    this.model = model;
    this.editorView = editorView;

    this.editorView.registerHandleView(this);

    this.model.hovered.onChange({}, function(val){
        self.hoverChanged(val);
    });
}


Handle3dView.prototype.subjectsChanged = function(subjects){
    console.error("Not Implimented");
};

Handle3dView.prototype.hoverChanged = function(value){
    console.error("Not Implimented");
};

module.exports = Handle3dView;
